export default "__VITE_ASSET__044e63df__"